import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Chip,
  LinearProgress,
  useTheme,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LaunchSharpIcon from "@mui/icons-material/LaunchSharp";
import axiosInstance from "../../../axios/axios";
import AgGridTable from "../../../components/table/AgGridTable";
import { sortBy } from "lodash";
import Exclamation from "../../../assets/Exclamation.png";
import AcceptedRisk_False from "../../../assets/baseVersion/AcceptedRisk_False.svg";
import sparkLogo from '../../../assets/Spark-text.svg'
// import csiLogo from '../../assets/cis.png'
import csiLogo from "../../../assets/cis_light.svg"
import nistLogo from '../../../assets/nist.svg'
import nist_dark from '../../../assets/nist_dark.svg';
import spark_dark from '../../../assets/spark_dark.svg'
import cis_dark from '../../../assets/cis_dark.svg';
import { ColDef } from "ag-grid-community";
const TagsOverlay = ({ tag }: { tag: string }) => {
  const [tab, setTab] = useState(0);
  const [rowData, setRowData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Determine module based on tab selection
  const module = tab === 0 ? "on_premise" : "cloud";

  //Scan Details API
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `securityscan/security-info?module=${module}`
        );
        if (response.data?.data) {
          const formattedData = response.data.data.map((control: any) => ({
            id: control.id,
            controls: control.param_name,
            asset_count: control.asset_count,
            compliance_passed_count: control.passed_asset_count,
            compliance_failed_count: control.compliance_failed_count,
            accepted_count: control.accepted_count,
            compliance_count: control.asset_passed_percent,
            tag_name: control.tag_name,
            parameter_type: control.parameter_type,
            severity: control.highest_priority,
            control_type: control.control_type,
            total_Count: control.total_asset_count,
          }));

          // Filter rows where tag_name includes the selected tag
          const filterData = formattedData.filter((data: any) =>
            data.tag_name
              ?.split(",")
              .map((t: string) => t.trim())
              .includes(tag)
          );

          setRowData(filterData);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [tab, tag]);

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const columnDefs :ColDef[] = [
    // {
    //   field: "id",
    //   headerName: "#",
    //   maxWidth: 50,
    //   valueGetter: (params: any) => params.node.rowIndex + 1,
    // },
    {
      field: "controls",
      headerName: "Recommendation",
      filter: false,
      sortable: false,
      minWidth: 300,
      width: 300,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        const color = isManual ? "#F7941F" : "#696595";

        return (
          <Tooltip title={value} arrow  slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#fff", 
            color: "#000",           
            boxShadow: 1,
            fontSize: "0.775rem",
          },
        },
        arrow: {
          sx: {
            color: "#fff",
          },
        },
      }}  placement="bottom">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                
                width: "100%",
                gap: 8,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  flex: 1,
                }}
              >
                {value}
              </Typography>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "tag_name",
      headerName: "Tags",
      filter: true,
      minWidth: 200,
      cellRenderer: (params: any) => {
        const getRandomColor = () => {
          const hue = Math.floor(Math.random() * 360);
          return {
            background: `hsl(${hue}, 70%, 80%)`,
            color: `hsl(${hue}, 50%, 20%)`,
          };
        };

        const tagString = params.data?.tag_name;
        const tagsArray = tagString.split(",").map((tag: any) => tag.trim());

        const visibleTags = tagsArray.slice(0, 1);
        const hiddenTags = tagsArray.slice(1);

        // Capitalize first letter utility
        const capitalize = (str: string) =>
          str.charAt(0).toUpperCase() + str.slice(1);

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {visibleTags.map((tag: string, index: number) => {
              // Apply specific styles to first and second tag
              let style = {};
              if (index === 0) {
                style = {
                  backgroundColor: "#0183191A",
                  color: "#018319",
                };
              } else if (index === 1) {
                style = {
                  backgroundColor: "#894B001A",
                  color: "#894B00",
                };
              } else {
                const random = getRandomColor();
                style = {
                  backgroundColor: random.background,
                  color: random.color,
                };
              }

              return (
                <Chip
                  key={index}
                  size="small"
                  label={capitalize(tag)}
                  style={{
                    ...style,
                    fontWeight: "bold",
                    borderRadius: 4,
                  }}
                />
              );
            })}

            {hiddenTags.length > 0 && (
              <Tooltip title={hiddenTags.join(", ")} arrow  slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#fff", // white background
            color: "#000",           // black text
            boxShadow: 1,
            fontSize: "0.775rem",
          },
        },
        arrow: {
          sx: {
            color: "#fff",
          },
        },
      }} placement="bottom">
                <Chip
                  size="small"
                  variant="outlined"
                  label={`+${hiddenTags.length}`}
                  sx={{
                    fontSize: "14px", 
                    height: "18px",
                    
                    borderRadius: "4px",
                    paddingX: "2px", 
                    border: "1px solid #BEBED1",
                    fontWeight: "bold",
                  }}
                />
              </Tooltip>
            )}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "control_type",
      headerName: "Benchmark",
      minWidth: 150,
      width: 200,
      cellRenderer: (params: any) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1 }}>
          {params.value?.includes('SPARK') && <img src={isDarkMode ? spark_dark : sparkLogo} alt="spark" height="24" />}
          {params.value?.includes('CIS') && <img src={isDarkMode ? cis_dark : csiLogo} alt="cis" height="24" />}
          {params.value?.includes('NIST') && <img src={isDarkMode ? nist_dark : nistLogo} alt="nist" height="12" />}
        </Box>
      )

    },
    {
      field: "severity",
      headerName: "Severity",
      filter: true,
      minWidth: 150,
      width: 200,
      cellRenderer: (params: any) => {
        const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      minWidth: 150,
      filter: true,
      width: 150,
             cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (<img
          src={AcceptedRisk_False}
          alt="warning"
          style={{ height: "20px" }}
        />),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },


    {
      field: "compliance_count",
      headerName: module === "on_premise" ? "Assets" : "Resources",
      minWidth: 150,
      width: 200,
      cellRenderer: (params: any) => {
        const passedCount = params.data.compliance_passed_count;
        const compliance_count = params.data.total_Count;
        const rawValue = params.value || 0;
        const progressValue = Number(rawValue.toFixed(2)); // Rounded to 2 decimals

        return (
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
            >
              <Typography variant="caption">
                {`${passedCount}/${compliance_count} (${progressValue}%)`}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={progressValue}
              sx={{
                height: 6,
                borderRadius: 3,
                bgcolor: "#f5f5f5",
                "& .MuiLinearProgress-bar": {
                  bgcolor:
                    progressValue >= 70
                      ? "#4caf50"
                      : progressValue >= 40
                      ? "#ff9800"
                      : "#f44336",
                },
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Box>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 0.5 }}>
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography fontSize="14px">On-prem</Typography>
              {/* <img
                src={Layer123}
                alt="Layer123"
                style={{ height: 22, cursor: "pointer" }}
                onClick={() => navigate("/on-premises/security-posture")}
              /> */}
              <LaunchSharpIcon
                sx={{
                  color: isDarkMode ? "white" : "black",
                  cursor: "pointer",
                  fontSize: "17px",
                }}
                onClick={() => navigate("/on-premises/security-posture")}
              />
            </Box>
          }
        />
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography fontSize="14px">Cloud</Typography>
              {/* <img
                src={Layer123}
                alt="Layer123"
                style={{ height: 22, cursor: "pointer" }}
                onClick={() => navigate("/cloud/security-posture")}
              /> */}
              <LaunchSharpIcon
                sx={{
                  color: isDarkMode ? "white" : "black",
                  cursor: "pointer",
                  fontSize: "17px",
                }}
                onClick={() => navigate("/cloud/security-posture")}
              />
            </Box>
          }
        />
      </Tabs>
      <AgGridTable
        columnDefs={columnDefs}
        data={rowData}
        showSearch={true}
        pagination={true}
        isLoading={isLoading}
        height={"calc(100vh - 128px)"}
      />
    </Box>
  );
};

export default TagsOverlay;
